var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 28",
    clipPath: "url(#clip0_462_2881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9738 17.4261C11.3179 17.8163 7.65087 17.8163 3.99495 17.4261C2.53717 17.2705 1.38574 16.1191 1.23015 14.6612C0.83995 11.0052 0.83995 7.33837 1.23015 3.68245C1.38574 2.22467 2.53717 1.07324 3.99495 0.917651C7.65087 0.52745 11.3177 0.52745 14.9737 0.917651C16.4316 1.07324 17.583 2.22467 17.7386 3.68245C18.1288 7.33837 18.1288 11.0052 17.7386 14.6612C17.583 16.1191 16.4317 17.2705 14.9738 17.4261Z",
    fill: "url(#paint0_linear_462_2881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.77823 12.8507C8.39844 12.8044 7.33047 12.7781 6.26381 12.7272C5.9383 12.7115 5.60326 12.6673 5.29496 12.5672C4.72752 12.383 4.40383 11.9681 4.31972 11.3688C4.15305 10.1814 4.16726 8.9899 4.23547 7.79777C4.25425 7.47043 4.31424 7.1457 4.3488 6.81914C4.41596 6.18363 5.04443 5.71727 5.63886 5.64841C7.01761 5.48826 8.40183 5.48369 9.78606 5.49686C10.7287 5.50586 11.6712 5.54121 12.6132 5.57837C12.9078 5.58998 13.204 5.62871 13.4935 5.68518C14.1315 5.80973 14.5006 6.2088 14.613 6.84979C14.765 7.71705 14.8048 8.59265 14.7729 9.46865C14.7487 10.1317 14.6804 10.7937 14.6117 11.4541C14.5358 12.183 13.9047 12.6146 13.3363 12.6521C12.0482 12.737 10.7587 12.7972 9.77823 12.8507Z",
    fill: "url(#paint1_linear_462_2881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.47656 10.785C9.3673 10.2382 10.2363 9.70437 11.1313 9.1548C10.2381 8.60588 9.36925 8.07196 8.47656 7.52344V10.785Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_2881",
    x1: 4.82607,
    y1: 0.197492,
    x2: 17.143,
    y2: 23.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_462_2881",
    x1: 8.83884,
    y1: 7.29815,
    x2: 10.4086,
    y2: 11.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B31217"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_2881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0938,
    height: 17.0938,
    fill: "white",
    transform: "translate(0.9375 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt3);
export default __webpack_public_path__ + "static/media/YT3.00e72ce248b93bf62537fdbb040c747e.svg";
export { ForwardRef as ReactComponent };